<router-outlet></router-outlet>
<app-toast></app-toast>
<div>
  <p-confirmDialog
    [header]="'common.confirm' | translate"
    styleClass="page confirm-dialog"
    acceptButtonStyleClass="btn-primary"
    rejectButtonStyleClass="btn-transparent"
    acceptIcon="pi pi-check"
    rejectIcon="pi pi-times"
  >
  </p-confirmDialog>
</div>
